import { ChangeEvent, useEffect, useState } from "react";
import { Dropdown } from "react-day-picker";
import { DropDownForm } from "src/components/common/form/DropdownForm";
import { AddressForm } from "src/components/common/form/address/AddressForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { formatPhoneNumber, formatRegNo } from "src/utils/string/stringUtil";

import { AddressJusoDto } from "src/dtos/address/addressApiResponseDto";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { BRDiv, inputAddressMRClass } from "src/components/common/common";
import { useMST2010_R01Store } from "./Store_MST2010_R01";



export const Info_MST2010_R01 = () => {

	const { editMST2010_R01, setEditMST2010_R01, selectedMST2010_R01 } = useMST2010_R01Store();
	const { areaCdList, moneyCdList, customTypeList } = useCommonCodeStore();
	const { setAddressModalProps } = useUiuxStore();

	const addressHandleFoucsId = 'addressInput';
	const addressWrapperStyle = {
		wrapperStyle: "w-[618px] mr-[2px]",
		postInputStyle: 'w-[50px] min-w-[50px]' + ' ' + inputAddressMRClass,
		buttonStyle: 'px-[12px]' + ' ' + inputAddressMRClass,
		titleStyle: 'w-[100px] min-w-[100px] text-left',
		inputStyle: 'w-[306px] min-w-[306px]',
		detailAddressInputStyle: 'w-[100px] min-w-[100px]',
	}

	const handleChange = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;

		setEditMST2010_R01({
			...editMST2010_R01,
			[name]: name === 'regNo' ? formatRegNo(value)
				: name === 'telNo' || name === 'faxNo' || name === 'taxTelNo' ? formatPhoneNumber(value)
					: value
		});
	}

	const handleAddressSearchClick = () => {
		console.log(editMST2010_R01);
		setAddressModalProps({
			onSelect: (data: AddressJusoDto) => {
				setEditMST2010_R01({
					...editMST2010_R01,
					post: data.zipNo,
					address: data.roadAddr
				})
				setAddressModalProps(undefined);
			}
		})
	}

	return (
	<div className="w-full h-full flex flex-col gap-[8px] border border-gray-300 px-[12px] py-[12px] overflow-y-auto">
		<div className="w-full h-full flex flex-wrap content-start p-[5px]">
			{/* selectedCustomer : {JSON.stringify(selectedCustomer)} */}
			<InputForm title="거래처코드" value={editMST2010_R01.customCd} editable={selectedMST2010_R01 === undefined} name="customCd" onChange={handleChange} />
			<InputForm title="사업자번호" value={editMST2010_R01.regNo} editable={true} name="regNo" onChange={handleChange} />
				<BRDiv />

			<InputForm title="상호" value={editMST2010_R01.customNm} editable={true} name="customNm" onChange={handleChange} />
			<InputForm title="상호(Full)" value={editMST2010_R01.customNmFull} editable={true} name="customNmFull" onChange={handleChange} />
			<InputForm title="대표자" value={editMST2010_R01.owner} editable={true} name="owner" onChange={handleChange} />
				<BRDiv />	

			<DropDownForm<SysCodeDto> title={"영업지역"} data={areaCdList} value={editMST2010_R01.areaCd} name="areaCd" initLabelLess={true} onChange={handleChange} />
			<InputForm title="업태" value={editMST2010_R01.businessType} editable={true} name="businessType" onChange={handleChange} />
			<InputForm title="종목" value={editMST2010_R01.businessClass} editable={true} name="businessClass" onChange={handleChange} />
				<BRDiv />
			<AddressForm	post={editMST2010_R01.post} address={editMST2010_R01.address} detailAddress={editMST2010_R01.detailAddress}
							onChange={handleChange}
							onSearchClick={handleAddressSearchClick} 
							handleFoucsId={addressHandleFoucsId}
							wrapperOption={addressWrapperStyle}
							/>
			<DropDownForm title={"기준화폐"} data={moneyCdList} value={editMST2010_R01.moneyCd} name="moneyCd" initLabelLess={true} onChange={handleChange} />
				<BRDiv />

			<InputForm title="전화번호" value={editMST2010_R01.telNo} editable={true} name="telNo" onChange={handleChange} />
			<InputForm title="팩스번호" value={editMST2010_R01.faxNo} editable={true} name="faxNo" onChange={handleChange} />
			<DropDownForm<SysCodeDto> title={"거래유형"} data={customTypeList} value={editMST2010_R01.customType} name="customType" initLabelLess={true} onChange={handleChange} />
				<BRDiv />

			<InputForm title="휴대폰(세금계산서)" value={editMST2010_R01.taxTelNo} editable={true} name="taxTelNo" onChange={handleChange} 
				wrapperOption={{
					wrapperStyle: "w-[300px] min-w-[300px] mr-[10px] mb-[5px]",
					titleStyle: "w-[120px] min-w-[120px] text-left",
					inputStyle: "w-[180px] min-w-[180px]",
				}} />
			<InputForm title="E-mail(세금계산서)" value={editMST2010_R01.taxEmail} editable={true} name="taxEmail" onChange={handleChange} 
				wrapperOption={{
					wrapperStyle: "w-[300px] min-w-[300px] mr-[10px] mb-[5px]",
					titleStyle: "w-[120px] min-w-[120px] text-left",
					inputStyle: "w-[180px] min-w-[180px]",
				}} />
				<BRDiv />
				
			<InputForm title="비고" value={editMST2010_R01.remark} editable={true} wrapperOption={{
				wrapperStyle: "w-[614px] mr-[6px] mb-[10px]",
				titleStyle: "w-[100px] min-w-[100px] text-left",
				inputStyle: "w-[510px] min-w-[510px]"
			}} name="remark" onChange={handleChange} />
			
		</div>
	</div>
	)
}